import store from '@/store';

// some initial setup logic for loading components
const componentClass = 'v-component';

export default {
  created: () => {
    // add the data attribute to the body tag
    // required for vuetify dialogs and other popup items
    document.body.setAttribute('data-app', 'true');
  },
  mounted: (options = {}) => {
    // add the component class to the parent selector
    // without this class utlity styles will not work
    const { direction = 'ltr', parentTarget } = options;

    // add a node to attach all external items to
    const exists = document.getElementById('ndfc-attach-node');

    if (!exists) {
      const node = document.createElement('div');
      node.id = 'ndfc-attach-node';
      // add classes to apply the style on vue project
      const classes = [
        'v-component',
        `v-component--is-${direction}`,
        'v-application',
        `v-application---is-${direction}`,
      ];

      classes.forEach((item) => {
        node.classList.add(item);
      });

      document.body.appendChild(node);
    }

    // body or vue app element
    const el = document.querySelector(parentTarget || 'body');
    // add initial direction class to body tag
    const dirClass = `v-component--is-${direction}`;
    if (!options.parentElement) {
      el.classList.add(dirClass);
      el.classList.add(componentClass);
    } else {
      options.parentElement.classList.add(dirClass);
      options.parentElement.classList.add(componentClass);
    }
    store.dispatch('ndc/app/setContext');
  },
};
